import { ST } from 'types';
import { IGeoLocationService } from '../';

class DummyGeoLocator implements IGeoLocationService {
  destroy() {}
  async getCurrentLocation(): Promise<ST.Location> {
    const result: ST.Location = {
      latitude: 47.8156,
      longitude: 9.058,
    };
    return Promise.resolve(result);
  }

  async getAddressFromLocation(_pos: ST.Location): Promise<string> {
    return 'Musterstraße 31, 12345 Musterstadt';
  }
}

export default DummyGeoLocator;
